import { BACKENDURL } from "../../../core/api/constants";

export default class AuthApi {
    static async signIn(username: string, password: string) {
        try {
            const response = await fetch(`${BACKENDURL}/api/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({ username, password }),
            });
            if (response.ok) {
                return {
                    isOk: true,
                };
            } else {
                return {
                    isOk: false,
                    message: "Authentication failed",
                };
            }
        } catch (error) {
            console.error("Error during the login process:", error);
            return {
                isOk: false,
                message: "Network error or server is down",
            };
        }
    }

    static async createAccount(email: string, password: string) {
        try {
            return {
                isOk: true,
            };
        } catch {
            return {
                isOk: false,
                message: "Failed to create account",
            };
        }
    }

    static async changePassword(email: string, recoveryCode?: string) {
        try {
            return {
                isOk: true,
            };
        } catch {
            return {
                isOk: false,
                message: "Failed to change password",
            };
        }
    }

    static async resetPassword(email: string) {
        try {
            return {
                isOk: true,
            };
        } catch {
            return {
                isOk: false,
                message: "Failed to reset password",
            };
        }
    }
}
